import { render, staticRenderFns } from "./visit-form.vue?vue&type=template&id=fe3882b8&scoped=true&lang=pug&"
import script from "./visit-form.vue?vue&type=script&lang=ts&"
export * from "./visit-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3882b8",
  null
  
)

export default component.exports